import geoApi from 'src/apis/geo'

export default {
  methods: {
    async getPoleByGeoInfo(lat, lon, geoLocStr = null) {
      if ((!lat || !lon) && !geoLocStr) { return }

      if (geoLocStr) {
        const locations = []
        const chunkSize = 2
        const geoLocations = geoLocStr.split(',')
        for (let i = 0; i < geoLocations.length; i += chunkSize) {
          const [lat, lon] = geoLocations.slice(i, i + chunkSize)
          locations.push({ lat: lat, lon: lon })
        }
        return await this.getPoleByLocations(locations)
      } else {
        return await this.getPoleByLocation(lat, lon)
      }
    },
    async getPoleByLocation(lat, lon) {
      const { data: { poles } } = await geoApi.getPoles(lat, lon)
      const pole = poles.slice().sort((a, b) => {
        const val1 = parseFloat(a.dist)
        const val2 = parseFloat(b.dist)
        return val1 - val2
      })[0]
      return pole
    },
    async getPoleByLocations(locations) {
      const { data: { res: poles } } = await geoApi.getPolesByLocations(locations)
      const pole = poles.slice().sort((a, b) => {
        const val1 = parseFloat(a.distance)
        const val2 = parseFloat(b.distance)
        return val1 - val2
      })[0]
      return pole
    },
    getPoleNoInputFormat(code) {
      let str = code

      // 全角を半角に変換
      str = str.replace(/[Ａ-Ｚａ-ｚ０-９－（）．]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      })
      // カンマより前を取得
      str = str.replace(/^([^,]*)(,.+)/, '$1')
      // 先頭「PO-99-」削除
      str = str.replace(/^PO-\d\d-/, '')
      // 先頭「PO-」削除
      str = str.replace(/^PO-/, '')
      // 先頭空白削除
      str = str.replace(/^\s+/, '')

      return str
    },
  }
}
